<template>
  <a-sub-menu :key="menuInfo.key" v-bind="$props" v-on="$listeners">
    <span slot="title">
      <span v-if="menuInfo.icon">
        <a-icon slot="trigger" :type="menuInfo.icon" />
      </span>
      <span :title="menuInfo.title">{{ menuInfo.title }}</span>
    </span>
    <template v-for="item in menuInfo.child">
      <a-menu-item v-if="!item.child" :key="item.key">
        <span :title="item.title">{{ item.title }}</span>
      </a-menu-item>
      <SubMenu v-else :key="item.key" :menu-info="item" />
    </template>
  </a-sub-menu>
</template>
<script>
import { Menu } from 'ant-design-vue'
export default {
  name: 'SubMenu',
  props: {
    ...Menu.SubMenu.props,
    // Cannot overlap with properties within Menu.SubMenu.props
    menuInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isSubMenu: true
    }
  }
}
</script>
